import type { MeetingPublic } from '@repo/types/meetings';
import type { DatetimeCursorPagination } from '@repo/types/pagination';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function useDeleteMeeting(params?: DatetimeCursorPagination) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => MeetingService.deleteMeeting(id).then((response) => response.data),
    onMutate: async (id: number) => {
      await queryClient.cancelQueries({ queryKey: [MeetingKey.MEETINGS] });
      const previousData = queryClient.getQueryData<MeetingPublic[]>([MeetingKey.MEETINGS, params]);

      queryClient.setQueryData([MeetingKey.MEETINGS, params], (prev?: MeetingPublic[]) => {
        if (!prev) {
          return [];
        }
        return prev.filter((meeting: MeetingPublic) => meeting.id !== id);
      });
      return { previousData };
    },
    onError: (_error, _id, context) => {
      if (context?.previousData) {
        queryClient.setQueryData([MeetingKey.MEETINGS, params], context.previousData);
      }
    },
    onSettled: (_data, _error, id) => {
      queryClient.removeQueries({ queryKey: [MeetingKey.MEETINGS, id] });
      queryClient.invalidateQueries({ queryKey: [MeetingKey.MEETINGS] });
    },
  });
}
